import { useEffect } from "react";

function setMeta(attr, key, content) {
  let tag = document.querySelector(`meta[${attr}="${key}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

// Lightweight SEO + social meta: title, description, canonical, Open Graph / Twitter tags,
// and optional JSON-LD structured data. Note: as a client-rendered SPA, social crawlers
// only reliably see server-served tags — article shares use the /api/share gateway for that.
export default function Seo({ title, description, image, type, url, jsonLd }) {
  useEffect(() => {
    if (title) {
      document.title = title;
      setMeta("property", "og:title", title);
      setMeta("name", "twitter:title", title);
    }
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }
    if (image) {
      setMeta("property", "og:image", image);
      setMeta("name", "twitter:image", image);
      setMeta("name", "twitter:card", "summary_large_image");
    }
    setMeta("property", "og:type", type || "website");
    setMeta("property", "og:site_name", "Transplant Story");
    if (url) {
      setMeta("property", "og:url", url);
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", url);
    }
    if (jsonLd) {
      let s = document.getElementById("seo-jsonld");
      if (!s) {
        s = document.createElement("script");
        s.type = "application/ld+json";
        s.id = "seo-jsonld";
        document.head.appendChild(s);
      }
      s.textContent = JSON.stringify(jsonLd);
    }
  }, [title, description, image, type, url, jsonLd]);
  return null;
}
